import React, { useState } from 'react';
import AddNewItemComponent from './AddNewItemComponent'
import OrganizerNavBar from './OrganizerNavBar'

import TaskTable from './TaskTable'
import ToastContainer from 'react-bootstrap/ToastContainer';
import Toast from 'react-bootstrap/Toast';
import { useEffect } from 'react';
import { baseURL } from "./utils";

import {authFetch,handleResponse} from './utils'

//class Organizer extends React.Component {

  function Organizer(props) {  
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [filterTaskName, setFilterTaskName] = useState(null);
    const [schedule, setSchedule] = useState("TODAY");
    const [show, setShow] = useState(false);
    const [searchTerm, setSearchTerm] = useState(null);
    const [toastMsg, setToastMsg] = useState("");
    const [categories, setCategories] = useState([]);
    const [items, setItems] = useState([]);
    const [refresh, setRefresh] = useState([]);
    const [unscheduledItems, setUnscheduledItems] = useState([]);
    const [projects, setProjects] = useState([]);
    const [areawiseEffort, setAreaWiseEffort] = useState({personalEffortPercentage:0,workEffortPercentage:0});
    const [areawiseCompletedEffort, setAreaWiseCompletedEffort] = useState({personalEffortPercentage:0,workEffortPercentage:0});
    var getCookie=function(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
    var defaultArea = getCookie("default_area");
    if(defaultArea==="")
      defaultArea= "PERSONAL";
   
    var toIsoDate= function(date){
      return date.toLocaleString("default", { year: "numeric" })+"-"+date.toLocaleString("default", { month: "2-digit" })+"-"+date.toLocaleString("default", { day: "2-digit" });
    }
    useEffect(() => {
    

        authFetch(baseURL+'/v1/task/category/')
        .then(res => handleResponse(res))
        .then((result) => {
          if(result.categories){
          const mappedCategories = result.categories.map(category=>{return {"label":category.name,"value":category.id}});
          setCategories(mappedCategories);}
        },        (error) => {
          
          setCategories([]);
          
        });
      }
      
    ,[])
    useEffect(() => {
     
 
      authFetch(baseURL+'/v1/task/project')
      .then(res => handleResponse(res))
      .then((result) => {
       setProjects(result.projects)
      },        (error) => {
        
        setCategories([]);
        
      });
    
    },[refresh])
    useEffect(() => {

   
      var url = baseURL+'/v1/task/?unscheduled=true';
      authFetch(url)
      .then(res => handleResponse(res))
      .then((result) => {setUnscheduledItems(result.tasks)})
    }
    ,[refresh])

    useEffect(() => {
      
      
    
      const fn = setTimeout(() => {
        if(searchTerm && searchTerm.length>2){
          setIsLoaded(false)
       
          var url = baseURL+'/v1/task/?searchTerm='+searchTerm;
          authFetch(url)
          .then(res => handleResponse(res))
          .then((result) => {setItems(result.tasks); setIsLoaded(true);})
        }else if(searchTerm!==null && searchTerm.length===0) {
          setRefresh(!refresh)
        }
      }, "2000");

      return () => clearTimeout(fn)
     
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ,[searchTerm])

    useEffect(() => {
   if(schedule!=='SELECT'){
       setIsLoaded(false)
        var date = null;
        var unscheduled = false;
        if(schedule==='TODAY'){
          date = toIsoDate(new Date())
        }else if(schedule==='NOT_SCHEDULED'){
          unscheduled = true;
        }else if(schedule!=='ALL'){
          date = toIsoDate(schedule)
        }
        var url = baseURL+'/v1/task/?unscheduled='+unscheduled;
        if(date!==null){
          url+="&date="+date;
        }
   
   
        authFetch(url)
        .then(res => handleResponse(res))
          .then(
    
            (result) => {
              result.tasks.sort(function (item1, item2) {
                if (item1.taskType === 'INBOX')
                  return -1;
                if (item2.taskType === 'INBOX')
                  return 1;
                if (item1.taskDetails.reminder != null && item2.taskDetails.reminder != null) {
                  var item1reminder = Date.parse(item1.taskDetails.reminder.time);
                  var item2reminder = Date.parse(item2.taskDetails.reminder.time);
                  return item1reminder - item2reminder;
                } else if (item1.taskDetails.reminder != null && item2.taskDetails.reminder == null) {
                  return -1;
                }
                else if (item1.taskDetails.reminder == null && item2.taskDetails.reminder != null) {
                  return 1;
                } else
                  return 0;
              });
              setItems(result.tasks);
              if(result.areawiseEffort!==null){
                setAreaWiseEffort(result.areawiseEffort)
                setAreaWiseCompletedEffort(result.areawiseCompletedEffort)
              }else{
                setAreaWiseEffort({ "personalEffortPercentage": 0,
                "workEffortPercentage": 0})
                setAreaWiseCompletedEffort({ "personalEffortPercentage": 0,
                "workEffortPercentage": 0})
              }
              setIsLoaded(true)
            },
            // Note: it's important to handle errors here     
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              console.log(error)
              setIsLoaded(true)
              setError(error)
            }
          )
          }
    },[schedule,refresh])
  //constructor(props) {
    //super(props);
   // this.onItemAdded = this.onItemAdded.bind(this);
    //this.componentDidUpdate = this.componentDidUpdate.bind(this);
   // this.componentDidMount = this.componentDidMount.bind(this);
   // this.onNewItemTextChange = this.onNewItemTextChange.bind(this);
  //  this.showToast = this.showToast.bind(this);
   // this.onScheduleTypeChange = this.onScheduleTypeChange.bind(this);
   /* this.state = {
      error: null,
      isLoaded: false,
      filterTaskName: null,
      schedule: 'TODAY',
      show: false,
      toastMsg: "",
      categories:[],
      items: []
    };
  }*/

  var refreshComponent = function(){
    setRefresh(!refresh)
  }

  
  //onNewItemTextChange(value) {
    // this.setState({ filterTaskName: value, schedule: "ALL" });

 // }
  //onScheduleTypeChange(value) {
    
   // this.setState({ schedule: value });
 // }
  var showToast = function(msg) {
    setToastMsg(msg)
    setShow(true)
  }
  /*var onItemAdded = function() {
    this.componentDidMount();
  }*/
  //render() {
    //this.componentDidMount2();
    //const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else {
      return (
        <div>
          <ToastContainer position='top-end'>
            <Toast bg="info" delay={4000} autohide show={show} onClose={() => setShow(false)}>
              <Toast.Header>
                <strong className="me-auto">Organizer</strong>
              </Toast.Header>
              <Toast.Body>{toastMsg}</Toast.Body>
            </Toast>
          </ToastContainer>
          <OrganizerNavBar onSearchChange={setSearchTerm} schedule={schedule} onScheduleTypeChange={setSchedule} unscheduledItems={unscheduledItems}></OrganizerNavBar>
          <div className="content-narrow">
          <AddNewItemComponent onChange={setSearchTerm} showFollowUp="false" completed="false" area="PERSONAL" showToast={showToast}  contexturl={props.contexturl} onItemAdded={refreshComponent} text='asdf' />
         {/**  <Button variant="success" type="button" onClick={(e) => refreshComponent()}>Refresh</Button> 
          <Button href="https://organizerassistant.b2clogin.com/organizerassistant.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_signupsignin1&client_id=419f1a53-b72f-467d-ab77-8d2bc79c0f5a&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fapp.organizer.lifekit.cloud&scope=openid&response_type=id_token&prompt=login" variant="success" type="button" >Login</Button>*/}
          
          <TaskTable setFilterTaskName={setFilterTaskName} defaultSelectedTab={defaultArea} isLoaded={isLoaded} areawiseCompletedEffort={areawiseCompletedEffort} areawiseEffort={areawiseEffort} projects={projects} unscheduledItems={unscheduledItems} categories={categories} showToast={showToast} onScheduleTypeChange={setSchedule} schedule={schedule} filterTaskName={filterTaskName} contexturl={props.contexturl} onItemChanged={refreshComponent} items={items} />
          </div>
        </div>
      );
    }
  }
//}

export default Organizer;
